module.exports = __webpack_public_path__ + "static/img/logo.04b8d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 404
// module chunks = 6 7 11 16 29 30 31 32 33 34 35 36 37